import { isObject } from '@pineapplelab/util';
import { Paging } from '../paging';
import { FBase } from './FBase';
import { ILandingPageServiceSuite } from 'src/app/interfaces/landing-page-service-suite.interface';
import { LandingPageServiceUtils } from 'src/app/utils/landing-page/landing-page-service.utils';
import { ILandingHeaderSections } from 'src/app/interfaces/landing-header-sections.interface';

export class LandingPageBanner extends FBase {

  whiteLogo: string = null;
  blackLogo: string = null;
  title: string  = null;
  highlightedText: string  = null;
  afterHighlightedText: string  = null;
  description: string = null;
  img: string = null;
  services: ILandingPageServiceSuite = { title: null, description: null, show: false, list: LandingPageServiceUtils.getEmptyServices() };
  showHeaderSections: ILandingHeaderSections = {
    services_text:'',
    services: false,
    about_us_text:'',
    aboutUs: false,
    projects_text:'',
    projects: false,
    blog_text:'',
    blog: false,
    careers_text:'',
    careers: false,
    contact_us_text:'',
    contact_us_link:'',
    contactUs: false,};
  companyHighlights: Partial<LandingPageBanner.ILandingPageCompanyHighlights>[] = [];
  showCompanyHighlights: boolean = false;
  language: string;

  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}
export namespace LandingPageBanner {
  export const PATH = 'landingPageBanner';

  export const PAGING = new Paging<LandingPageBanner>(<Paging.IPaging>{
    collection: PATH,
    orderOptions: [{ field: 'projectName', label: 'Project Name', placeholder: 'Filter by category', dataType: Paging.dataType.string }],
    orderBy: 'projectName',
  });
  export interface ILandingPageCompanyHighlights {
    title: string;
    img: string;
    __fileImage: File;
  }
}
